import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

// Remote

export const GET_PAYOUTS = gql`
  query PayOuts($projectId: ID!) {
    payOuts(projectId: $projectId) {
      ...PayOut
    }
  }
  ${fragments.payOut}
`

export const _ADD_PAYOUT = gql`
  mutation _AddPayOut($projectId: ID!, $input: PayOutInput!) {
    _addPayOut(projectId: $projectId, payOutInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const ADD_PAYOUT = gql`
  mutation AddPayOut($projectId: ID!, $input: PayOutInput!) {
    addPayOut(projectId: $projectId, payOutInput: $input) {
      ...PayOut
    }
  }
  ${fragments.payOut}
`

export const _SAVE_PAYOUT = gql`
  mutation _SavePayOut($payOutId: ID!, $input: PayOutInput!) {
    _savePayOut(payOutId: $payOutId, payOutInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _DELETE_PAYOUT = gql`
  mutation _DeletePayOut($payOutId: ID!) {
    _deletePayOut(payOutId: $payOutId) {
      ...Project
    }
  }
  ${fragments.project}
`

const mutations = {
  addRemote: _ADD_PAYOUT,
  saveRemote: _SAVE_PAYOUT,
  deleteRemote: _DELETE_PAYOUT,
  saveOp: '_savePayOut',
  addOp: '_addPayOut',
  deleteOp: '_deletePayOut',
}

export const payOutsQueries = { ...mutations, getRemote: GET_PAYOUTS }
